import { render, staticRenderFns } from "./CircularCarousel.vue?vue&type=template&id=61bd9cf7&scoped=true&"
import script from "./CircularCarousel.vue?vue&type=script&lang=js&"
export * from "./CircularCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CircularCarousel.vue?vue&type=style&index=0&id=61bd9cf7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd9cf7",
  null
  
)

export default component.exports